import React from "react";
import warningImg from "../../../assets/images/icons/alert.svg";

const Toast = ({
  show,
  setShow,
  message,
  icon = warningImg,
  success = false,
}) => {
  return (
    <div
      className="wrapper-container"
      style={{ position: "fixed", left: "0px", top: "0px" }}
    >
      <div className={`wrapper ${!show ? "hide" : ""}`}>
        <div
          className="toast"
          style={{ borderColor: success ? "#2ecc71" : "#ea4337" }}
        >
          <div className="content">
            <div
              className="icon"
              style={{ background: success ? "#2ecc71" : "#ea4337" }}
            >
              <img src={icon} className="success-icon" alt={`${icon}-icon`} />
            </div>
            <div className="details">{message}</div>
          </div>
          <div className="close-icon" onClick={() => setShow(false)}>
            <div className="close">x</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;
